import { LINK_URL } from 'infrastructure/config/CONSTANTS';
import { Link } from 'react-router-dom';
import { commonHelpers } from 'utilities/helpers';
import { RateBadge } from '../../CU-002-01/components/Rate';

interface props {
    data?: any;
}

const ContentComponent = ({ data }: props) => {
    return (
        <div className="content-infor">
            <div className="row-infor">
                <div className="text-label">即決価格</div>
                <div className="text-number">
                    <div className="text-money">
                        <span className="mkp-number">
                            {commonHelpers
                                .roundTenThousandYen(data?.askingSalePriceUpperLimit)
                                .toLocaleString('en-US', {
                                    maximumFractionDigits: 2,
                                })}
                        </span>
                        <span className="mkp-unit"> 万円</span>
                    </div>
                    <RateBadge value={data?.rateBuyNow} fill="#ffffff" />
                </div>
            </div>
            <div className="row-infor">
                <div className="text-label">現在の最高入札額</div>
                <div className="text-number">
                    <div className="text-money">
                        <span className="mkp-number">
                            {commonHelpers
                                .roundTenThousandYen(
                                    data?.currentHighestAuctionPrice
                                )
                                .toLocaleString('en-US', {
                                    maximumFractionDigits: 2,
                                })}
                        </span>
                        <span className="mkp-unit"> 万円</span>
                    </div>
                    <RateBadge
                        value={data?.currentHighestAuctionPrice ? data?.rateHighestAuctionNow : 0}
                        fill="#ffffff"
                    />
                </div>
            </div>
            {data?.auctionTime && data?.yourAuctionBid && data.auctionStatus && (
                <div className="row-infor">
                    <div className="text-label">あなたの入札額</div>
                    <div className="text-number">
                        <div className="text-money">
                            <span className="mkp-number">
                                {commonHelpers
                                    .roundTenThousandYen(data?.yourAuctionBid)
                                    .toLocaleString('en-US', {
                                        maximumFractionDigits: 2,
                                    })}
                            </span>
                            <span className="mkp-unit"> 万円</span>
                        </div>
                        <RateBadge value={data?.rateYourAuctionBids} fill="#ffffff" />
                    </div>
                </div>
            )}
            <div className="text-note">※ 最低落札価格が設定されています。</div>
            <div className="text-end">
                詳しくは
                <a href={LINK_URL.REGISTER_BID_PRICE_DETAIL} target="_blank" rel="noopener noreferrer" className="link-component">
                    こちら
                </a>
            </div>
        </div>
    );
};

export default ContentComponent;
